module.exports = __webpack_public_path__ + "static/media/note_add_white_24dp.e4262ef4.svg";